import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const SOILS_AND_GEOLOGY: Layer = {
  id: ConstraintsCategory.SOILS_AND_GEOLOGY,
  layerType: ConstraintsLayerType,
  hideByDefault: true,
  group: LayerGroup.ENVIRONMENTAL,
  icon: "lt-layer-agricultural-land",
  description: "Suitability of soil for development",
  title: "Soil",
  requiredFeatureAccess: [Feature.geologyLayer],
  toggleable: true,
  layerConfig: {
    rootCategory: ConstraintsCategory.SOILS_AND_GEOLOGY,
    categorySchema: [{ key: "ssurgo" }, { key: "ssurgo_hydric" }],
  },
  zoomConfig: {
    minVisualisationZoom: 10,
  },
};
